import { render, staticRenderFns } from "./AboutChatMessage.vue?vue&type=template&id=606085e5&scoped=true"
import script from "./AboutChatMessage.vue?vue&type=script&lang=ts"
export * from "./AboutChatMessage.vue?vue&type=script&lang=ts"
import style0 from "./AboutChatMessage.vue?vue&type=style&index=0&id=606085e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606085e5",
  null
  
)

export default component.exports